export default "__VITE_ASSET__55605629__"